import React, { useEffect } from 'react'
import FormSection from 'src/shared/components/forms/FormSection/FormSection'
import FormSectionRow from 'src/shared/components/forms/FormSectionRow/FormSectionRow'
import InputTabs from 'src/shared/components/forms/input-tabs/InputTabs'
import InputTextSuggestions from 'src/shared/components/forms/input-text-suggestions/InputTextSuggestions'
import InputMoney from 'src/shared/components/forms/InputMoney/InputMoney'
import { times } from 'src/shared/helpers/calculator'
import accountBoxFill from 'src/shared/icons/accountBoxFill'
import DollarCircle from 'src/shared/icons/DollarCircle'
import { ExtensionEstanciaValues } from '../../EstensionEstancia-types'
import { Controller, useFormContext } from 'react-hook-form'
import { useCosts } from '../../context/CostContext'
import { ModalidadDePago, TiposPagos, useGetColaboradoresQuery } from 'src/gql/schema'
import { useProfile } from 'src/shared/hooks/useProfile'
import { PAYMENT_TYPES } from 'src/constants/payments'
import { formatCurrencyToFixed } from 'src/shared/hooks/formatCurrency'

const Propina = ({loading}: {loading?: boolean}) => {

    const {
        control,
        watch,
        setValue
    } = useFormContext<ExtensionEstanciaValues>()

    const { costs } = useCosts()
    const { hotel_id } = useProfile()
    const { data: colaboradores } = useGetColaboradoresQuery({
        variables: {
            hotel_id,
        },
    })

    const porcentajePropina = watch("pago.items.0.propina.porcentaje")
    const tipoPago = watch("pago.type")
    const metodoPago = watch("pago.mainMethod")

    const propinas = watch("pago.items")?.filter(item => item.propina)?.map(i => i.propina) || []


    useEffect(() => {
        setValue("pago.items.0.propina.monto", 0)
    }, [porcentajePropina])
    

    return (tipoPago as ModalidadDePago) === ModalidadDePago.Total && 
    ![PAYMENT_TYPES.Cortesia, PAYMENT_TYPES.ConsumoInterno, PAYMENT_TYPES.mixto, PAYMENT_TYPES.LovePoints].includes(metodoPago as TiposPagos) && !loading && (
        <FormSection toggable title="Propina (opcional)">
            <FormSectionRow style={{ alignItems: "center" }}>
                <Controller
                    control={control}
                    name="pago.items.0.propina.porcentaje"
                    render={({ field: { value, onChange } }) =>
                        <InputTabs
                            className={"registro-incidencia__tabs-place"}
                            label={"Monto o porcentaje"}
                            items={[
                                {
                                    bigLabel: "10%",
                                    label: `${formatCurrencyToFixed(times(costs.totalConIva, 0.1))}`,
                                    value: "0.1",
                                },
                                {
                                    bigLabel: "15%",
                                    label: `${formatCurrencyToFixed(times(costs.totalConIva, 0.15))}`,
                                    value: "0.15",
                                },
                                {
                                    label: "Otro monto",
                                    icon: "dollarCircle",
                                    value: "Otro",
                                },
                            ]}
                            withCheckOnSelected
                            value={value || ""}
                            onChange={onChange}
                        />
                    }
                />
                {porcentajePropina === "Otro" && (
                    <Controller
                        control={control}
                        name="pago.items.0.propina.monto"
                        rules={{ required: true, validate: (v) => (v || 0) > 0 }}
                        render={({
                            field: { onChange, value },
                            fieldState: { error },
                        }) => (<InputMoney
                            value={value}
                            onChange={onChange}
                            inputWrapperClass="venta-habitacion-input"
                            placeholder="Monto de propina"
                            label="Monto de propina"
                            icon={DollarCircle}
                            error={false}
                            errorhinttext={
                                error?.type === "validate"
                                    ? "Ingresa una propina mayor a 0"
                                    : ""
                            }
                        />)}
                    />
                )}
            </FormSectionRow>
            <FormSectionRow>
                <Controller
                    control={control}
                    name="pago.items.0.propina.colaboradorPropina"
                    rules={{
                        required: !!propinas[0]?.monto || !!propinas[0]?.porcentaje,
                        validate: (v) =>
                            (!propinas[0]?.monto && !propinas[0]?.porcentaje) || (!!v?.id && !!v?.title),
                    }}
                    render={({ field: { value, onChange }, fieldState: { error } }) =>
                        <InputTextSuggestions
                            suggestionsListWidth="255px"
                            className="venta-habitacion-input"
                            suggestions={
                                colaboradores?.colaboradores?.map((c) => ({
                                    title: `${c.nombre} ${c.apellido_paterno} ${c.apellido_materno}`,
                                    id: c.colaborador_id,
                                })) || []
                            }
                            value={value}
                            inputTextConfig={{
                                label: "¿Quién recibió la propina?",
                                placeholder: "Nombre del personal",
                                type: "text",
                                icon: accountBoxFill,
                                error: !!error,
                                errorhinttext: (error?.type === "validate" ||
                                    error?.type === "required")
                                    ? "Escribe el nombre del responsable"
                                    : ""
                            }}
                            onChange={onChange}
                        />
                    }
                />
            </FormSectionRow>
        </FormSection>
    )
}

export default Propina